import { storeUserData } from "../../../../redux/features/auth/authSlice";
import { consumeForceLogout, getCookie, hasForceLogout } from "utils/cookie";
import { getApiErrorMessage } from "utils/errors";
import { handlePostLoginRedirect } from "./authRedirect";

export function isCompanyNotFoundError(value) {
  const message = getApiErrorMessage(value, "").toLowerCase();
  return message.includes("company not found");
}

export function resolveSocialStartUrl(redictUrl) {
  if (!redictUrl || typeof redictUrl !== "string") return null;
  const trimmed = redictUrl.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }
  const envBase = String(process.env.REACT_APP_API_URL || "").replace(
    /\/$/,
    ""
  );
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";
  const base = envBase || origin;
  if (!base) return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${base}${trimmed.startsWith("/") ? "" : "/"}${trimmed}`;
}

export function getSocialFetchCredentials(url) {
  try {
    const target = new URL(url, window.location.origin);
    return target.origin === window.location.origin ? "include" : "omit";
  } catch {
    return "omit";
  }
}

export function getUsableAuthCookie() {
  if (hasForceLogout()) return null;
  return getCookie("api_key") || getCookie("API-KEY") || null;
}

function goSignup() {
  try {
    localStorage.setItem("showGoogleModal", "true");
  } catch {
    /* ignore */
  }
  window.location.replace("/signup");
}

function goLogin() {
  window.location.replace("/login");
}

let socialCompleteInFlight = false;

export function resetSocialCompleteLockForTests() {
  socialCompleteInFlight = false;
}

/**
 * Finish Google/Xero after /social/complete.
 * Never treats HTML/302/parse errors as "new user".
 * Signup only when the server says the company is missing.
 */
export async function completeSocialLoginAndRedirect() {
  if (socialCompleteInFlight) {
    return { status: "busy" };
  }
  socialCompleteInFlight = true;

  const apiBase = String(
    process.env.REACT_APP_API_URL || window.location.origin || ""
  ).replace(/\/$/, "");

  let successPayload = null;

  try {
    const response = await fetch(`${apiBase}/api/1/login/success`, {
      method: "GET",
      credentials: getSocialFetchCredentials(`${apiBase}/api/1/login/success`),
    });
    const text = await response.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = null;
    }

    if (isCompanyNotFoundError(data) || isCompanyNotFoundError(text)) {
      goSignup();
      return { status: "signup" };
    }

    if (response.ok) {
      successPayload = data && typeof data === "object" ? data : {};
      storeUserData(successPayload);
    }
  } catch {
    // Network / CORS — a cookie set by Django complete is still enough.
  }

  const cookie = getUsableAuthCookie();
  if (cookie) {
    consumeForceLogout();
    handlePostLoginRedirect(successPayload || {});
    return { status: "ok" };
  }

  goLogin();
  return { status: "login" };
}
